module.exports = __webpack_public_path__ + "static/media/create_success_icon.70041bc7.svg";